// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Ay4K","buttons":"SendReceipts_buttons__2W-97","email":"SendReceipts_email__1JPHG","bookApptTitle":"SendReceipts_bookApptTitle__3rRJN"};